module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"rate":"Please rate our service","rateWarning":"We need your rating","review":"Your review","placeholder":"What did you like or dislike from our service?","send":"Send","thanks":"Thank you for your review!"}}')
  delete Component.options._Ctor
}
